import {
  Injectable
} from '@angular/core';
import { map } from 'rxjs/operators';
import { CMG } from '../models/cmg.model';
import { HttpApiService } from './http/http-api.service';
import { HttpRequestMethod } from './http/request-methods';

@Injectable({
  providedIn: 'root'
})
export class CmgService {

  constructor( private httpApiService: HttpApiService) {}
  getCMG() {
    return this.httpApiService.apiNode<any>(HttpRequestMethod.GET,'cmg/getCMG');
  }
  onDeleteCMG(cmgId: number){
    return this.httpApiService.apiNode<any>(HttpRequestMethod.GET,`cmg/getDeleteCMG/${cmgId}`);
  }
  getEditCMG(cmgId: number) {
    return this.httpApiService.apiNode<any>(HttpRequestMethod.GET,`cmg/getEditCMG/${cmgId}`);
  }
  getLiderList(cmgId: number){
    return this.httpApiService.apiNode<any>(HttpRequestMethod.GET,`cmg/getLiderList/${cmgId}`)
    .pipe(
      map((res: any) => {
        return res.data.map((data) =>(data.liderId));
      })
    );
  }
  getBuyerList(cmgId: number){
    return this.httpApiService.apiNode<any>(HttpRequestMethod.GET,`cmg/getBuyerList/${cmgId}`)
    .pipe(
      map((res: any) => {
        return res.data.map((data) =>(data.buyerId));
      })
    );
  }
  getLiderListByCmgName(cmg: string){
    return this.httpApiService.apiNode<any>(HttpRequestMethod.GET,`cmg/getLiderListByCmgName/${cmg}`)
    .pipe(
      map((res: any) => {
        return res.data.map((data) =>(data.liderId));
      })
    );
  }
  getDepartment() {
    return this.httpApiService.apiNode<any>(HttpRequestMethod.GET,'cmg/getDepartment');
  }
  getCategory() {
    return this.httpApiService.apiNode<any>(HttpRequestMethod.GET,`cmg/getCategory`);
  }
  // getSubCategory(categoryId: number) {
  //   return this.httpApiService.apiNode<any>(HttpRequestMethod.GET,`cmg/getSubCategory/${categoryId}`);
  // }
  getLlenaCombosCMGEdit(cmg: string){
    return this.httpApiService.apiNode<any>(HttpRequestMethod.GET,`cmg/getLlenaCombosCMGEdit/${cmg}`);
  }

  saveCMG(editCMG: CMG, liderList: any, buyerList: any){
    const params = {
      editCMG: editCMG,
      liderList: liderList,
      buyerList: buyerList
    };
    return this.httpApiService.apiNode<any>(HttpRequestMethod.POST,`cmg/saveCMG`,params);
  }
  getCMGCatalog(){
    return this.httpApiService.apiNode<any>(HttpRequestMethod.GET,`cmg/getCMGCatalog`);
  }
  getSocialRassonRequest() {
    return[
      {
        name:"CERVEZAS CUAUHTEMOC MOCTEZUMA S.A DE C.V.",
      },
      {
        name:"CERVECERIA CUAUHTEMOC MOCTEZUMA S.A DE C.V."
      },
      {
        name:"GRUPO CUAUHTEMOC MOCTEZUMA S.A DE C.V."
      },
      {
        name:"COMERDIS DEL NORTE S.A DE C.V."
      },
      {
        name:"CONTROLADORA DE NEGOCIOS COMERCIALES S.A DE C.V."
      },
      {
        name: "SISTEMA AMBIENTAL INDUSTRIAL S.A DE C.V."
      },
      {
        name: "BOCK S.A DE C.V."
      }
    ].sort((a, b) => { return (a.name > b.name ? 1 : (a === b ? 0 : -1)) });
    //.sort((a, b) => b.name.localeCompare(a.name) );
  };
  getcmgs() {
    return[
      {
        cmg: 'CMG0119',
        desc: 'Assessment (Centres)',
        leader: 'Carlo Garza',
        level1: 'C',
        level1Cat: 'Business Services',
        level2: 'CA',
        level2Cat: 'HR',
        level3: 'CA02',
        level3Cat: 'HR Procurement'
      },
      {
        cmg: 'CMG0120',
        desc: 'Coaching',
        leader: 'Carlo Garza',
        level1: 'C',
        level1Cat: 'Business Services',
        level2: 'CA',
        level2Cat: 'HR',
        level3: 'CA02',
        level3Cat: 'HR Procurement'
      },
      {
        cmg: 'CMG0121',
        desc: 'Executive Search',
        leader: 'Carlo Garza',
        level1: 'C',
        level1Cat: 'Business Services',
        level2: 'CA',
        level2Cat: 'HR',
        level3: 'CA02',
        level3Cat: 'HR Procurement'
      },
      {
        cmg: 'CMG0122',
        desc: 'Outplacement',
        leader: 'Carlo Garza',
        level1: 'C',
        level1Cat: 'Business Services',
        level2: 'CA',
        level2Cat: 'HR',
        level3: 'CA02',
        level3Cat: 'HR Procurement'
      },
      {
        cmg: 'CMG0123',
        desc: 'Payrolling Services',
        leader: 'Carlo Garza',
        level1: 'C',
        level1Cat: 'Business Services',
        level2: 'CA',
        level2Cat: 'HR',
        level3: 'CA02',
        level3Cat: 'HR Procurement'
      },
      {
        cmg: 'CMG0124',
        desc: 'Pension Services',
        leader: 'Carlo Garza',
        level1: 'C',
        level1Cat: 'Business Services',
        level2: 'CA',
        level2Cat: 'HR',
        level3: 'CA02',
        level3Cat: 'HR Procurement'
      },
      {
        cmg: 'CMG0125',
        desc: 'Recruitment and Selection incl Job boards',
        leader: 'Carlo Garza',
        level1: 'C',
        level1Cat: 'Business Services',
        level2: 'CA',
        level2Cat: 'HR',
        level3: 'CA02',
        level3Cat: 'HR Procurement'
      },
      {
        cmg: 'CMG0126',
        desc: 'Relocation/Expat Services',
        leader: 'Carlo Garza',
        level1: 'C',
        level1Cat: 'Business Services',
        level2: 'CA',
        level2Cat: 'HR',
        level3: 'CA02',
        level3Cat: 'HR Procurement'
      },
      {
        cmg: 'CMG0127',
        desc: 'Training Services',
        leader: 'Carlo Garza',
        level1: 'C',
        level1Cat: 'Business Services',
        level2: 'CA',
        level2Cat: 'HR',
        level3: 'CA02',
        level3Cat: 'HR Procurement'
      },
      {
        cmg: 'CMG0128',
        desc: 'Meals & Drinks - Domestic & Abroad',
        leader: 'Carlo Garza',
        level1: 'C',
        level1Cat: 'Business Services',
        level2: 'CA',
        level2Cat: 'HR',
        level3: 'CA03',
        level3Cat: 'Personnel Expenses'
      },
      {
        cmg: 'CMG0129',
        desc: 'Other Personal Expenses',
        leader: 'Carlo Garza',
        level1: 'C',
        level1Cat: 'Business Services',
        level2: 'CA',
        level2Cat: 'HR',
        level3: 'CA03',
        level3Cat: 'Personnel Expenses'
      },
      {
        cmg: 'CMG0130',
        desc: 'Freelance/Independent Contractors',
        leader: 'Carlo Garza',
        level1: 'C',
        level1Cat: 'Business Services',
        level2: 'CA',
        level2Cat: 'HR',
        level3: 'CA04',
        level3Cat: 'Temporary labour'
      },
      {
        cmg: 'CMG0131',
        desc: 'Temporary labour',
        leader: 'Carlo Garza',
        level1: 'C',
        level1Cat: 'Business Services',
        level2: 'CA',
        level2Cat: 'HR',
        level3: 'CA04',
        level3Cat: 'Temporary labour'
      },
      {
        cmg: 'CMG0132',
        desc: 'Flights - Domestic & Abroad',
        leader: 'Carlo Garza',
        level1: 'C',
        level1Cat: 'Business Services',
        level2: 'CA',
        level2Cat: 'HR',
        level3: 'CA05',
        level3Cat: 'Travel'
      },
      {
        cmg: 'CMG0133',
        desc: 'Hotels - Domestic & Abroad',
        leader: 'Carlo Garza',
        level1: 'C',
        level1Cat: 'Business Services',
        level2: 'CA',
        level2Cat: 'HR',
        level3: 'CA05',
        level3Cat: 'Travel'
      },
      {
        cmg: 'CMG0134',
        desc: 'Meetings & Conferences',
        leader: 'Carlo Garza',
        level1: 'C',
        level1Cat: 'Business Services',
        level2: 'CA',
        level2Cat: 'HR',
        level3: 'CA05',
        level3Cat: 'Travel'
      },
      {
        cmg: 'CMG0135',
        desc: 'Public Transport - Rail/Bus - Domestic & Abroad',
        leader: 'Carlo Garza',
        level1: 'C',
        level1Cat: 'Business Services',
        level2: 'CA',
        level2Cat: 'HR',
        level3: 'CA05',
        level3Cat: 'Travel'
      },
      {
        cmg: 'CMG0136',
        desc: 'Short-term Car Rentals',
        leader: 'Carlo Garza',
        level1: 'C',
        level1Cat: 'Business Services',
        level2: 'CA',
        level2Cat: 'HR',
        level3: 'CA05',
        level3Cat: 'Travel'
      },
      {
        cmg: 'CMG0137',
        desc: 'Taxi - Domestic & Abroad',
        leader: 'Carlo Garza',
        level1: 'C',
        level1Cat: 'Business Services',
        level2: 'CA',
        level2Cat: 'HR',
        level3: 'CA05',
        level3Cat: 'Travel'
      },
      {
        cmg: 'CMG0138',
        desc: 'Travel - Other',
        leader: 'Carlo Garza',
        level1: 'C',
        level1Cat: 'Business Services',
        level2: 'CA',
        level2Cat: 'HR',
        level3: 'CA05',
        level3Cat: 'Travel'
      },
      {
        cmg: 'CMG0139',
        desc: 'Travel Management Services',
        leader: 'Carlo Garza',
        level1: 'C',
        level1Cat: 'Business Services',
        level2: 'CA',
        level2Cat: 'HR',
        level3: 'CA05',
        level3Cat: 'Travel'
      },
      {
        cmg: 'CMG0152',
        desc: 'Audit Fees',
        leader: 'Carlo Garza',
        level1: 'C',
        level1Cat: 'Business Services',
        level2: 'CC',
        level2Cat: 'Professional Services',
        level3: 'CC01',
        level3Cat: 'Audit Services'
      },
      {
        cmg: 'CMG0153',
        desc: 'Financial Consultancy',
        leader: 'Carlo Garza',
        level1: 'C',
        level1Cat: 'Business Services',
        level2: 'CC',
        level2Cat: 'Professional Services',
        level3: 'CC02',
        level3Cat: 'Consultancy'
      },
      {
        cmg: 'CMG0154',
        desc: 'Legal Consultancy',
        leader: 'Carlo Garza',
        level1: 'C',
        level1Cat: 'Business Services',
        level2: 'CC',
        level2Cat: 'Professional Services',
        level3: 'CC02',
        level3Cat: 'Consultancy'
      },
      {
        cmg: 'CMG0155',
        desc: 'Organizational Consultancy',
        leader: 'Carlo Garza',
        level1: 'C',
        level1Cat: 'Business Services',
        level2: 'CC',
        level2Cat: 'Professional Services',
        level3: 'CC02',
        level3Cat: 'Consultancy'
      },
      {
        cmg: 'CMG0156',
        desc: 'Strategic Consultancy',
        leader: 'Carlo Garza',
        level1: 'C',
        level1Cat: 'Business Services',
        level2: 'CC',
        level2Cat: 'Professional Services',
        level3: 'CC02',
        level3Cat: 'Consultancy'
      },
      {
        cmg: 'CMG0157',
        desc: 'Technical Consultancy',
        leader: 'Carlo Garza',
        level1: 'C',
        level1Cat: 'Business Services',
        level2: 'CC',
        level2Cat: 'Professional Services',
        level3: 'CC02',
        level3Cat: 'Consultancy'
      },
      {
        cmg: 'CMG0158',
        desc: 'Insurance - Premiums Employee Benefits',
        leader: 'Carlo Garza',
        level1: 'C',
        level1Cat: 'Business Services',
        level2: 'CC',
        level2Cat: 'Professional Services',
        level3: 'CC03',
        level3Cat: 'Insurance'
      },
      {
        cmg: 'CMG0159',
        desc: 'Insurance - Premiums Non-Employee Benefits',
        leader: 'Carlo Garza',
        level1: 'C',
        level1Cat: 'Business Services',
        level2: 'CC',
        level2Cat: 'Professional Services',
        level3: 'CC03',
        level3Cat: 'Insurance'
      },
      {
        cmg: 'CMG0160',
        desc: 'Medical Services',
        leader: 'Carlo Garza',
        level1: 'C',
        level1Cat: 'Business Services',
        level2: 'CC',
        level2Cat: 'Professional Services',
        level3: 'CC04',
        level3Cat: 'Other Professional Services'
      },
      {
        cmg: 'CMG0161',
        desc: 'Memberships',
        leader: 'Carlo Garza',
        level1: 'C',
        level1Cat: 'Business Services',
        level2: 'CC',
        level2Cat: 'Professional Services',
        level3: 'CC04',
        level3Cat: 'Other Professional Services'
      },
      {
        cmg: 'CMG0162',
        desc: 'Patents and Trademarks',
        leader: 'Carlo Garza',
        level1: 'C',
        level1Cat: 'Business Services',
        level2: 'CC',
        level2Cat: 'Professional Services',
        level3: 'CC04',
        level3Cat: 'Other Professional Services'
      },
      {
        cmg: 'CMG0163',
        desc: 'Public Relations',
        leader: 'Carlo Garza',
        level1: 'C',
        level1Cat: 'Business Services',
        level2: 'CC',
        level2Cat: 'Professional Services',
        level3: 'CC04',
        level3Cat: 'Other Professional Services'
      },
      {
        cmg: 'CMG0164',
        desc: 'Subscriptions and Publications',
        leader: 'Carlo Garza',
        level1: 'C',
        level1Cat: 'Business Services',
        level2: 'CC',
        level2Cat: 'Professional Services',
        level3: 'CC04',
        level3Cat: 'Other Professional Services'
      },
      {
        cmg: 'CMG0165',
        desc: 'Translation Services',
        leader: 'Carlo Garza',
        level1: 'C',
        level1Cat: 'Business Services',
        level2: 'CC',
        level2Cat: 'Professional Services',
        level3: 'CC04',
        level3Cat: 'Other Professional Services'
      },
      {
        cmg: 'CMG0166',
        desc: 'Tax Advisory Expenses & Services',
        leader: 'Carlo Garza',
        level1: 'C',
        level1Cat: 'Business Services',
        level2: 'CC',
        level2Cat: 'Professional Services',
        level3: 'CC05',
        level3Cat: 'Tax Services'
      },
      {
        cmg: 'CMG0392',
        desc: 'Finished Products - Cider',
        leader: 'Carlo Garza',
        level1: 'G',
        level1Cat: 'Finished Products',
        level2: 'GA',
        level2Cat: 'Finished Products - Beverages',
        level3: 'GA03',
        level3Cat: 'Finished Products - Cider'
      },
      {
        cmg: 'CMG0393',
        desc: 'Finished Products - Cola',
        leader: 'Carlo Garza',
        level1: 'G',
        level1Cat: 'Finished Products',
        level2: 'GA',
        level2Cat: 'Finished Products - Beverages',
        level3: 'GA07',
        level3Cat: 'Finished Products - Softdrink'
      },
      {
        cmg: 'CMG0394',
        desc: 'Finished Products - Other Softdrinks',
        leader: 'Carlo Garza',
        level1: 'G',
        level1Cat: 'Finished Products',
        level2: 'GA',
        level2Cat: 'Finished Products - Beverages',
        level3: 'GA07',
        level3Cat: 'Finished Products - Softdrink'
      },
      {
        cmg: 'CMG0395',
        desc: 'Finished Products - (Fruit) Juice',
        leader: 'Carlo Garza',
        level1: 'G',
        level1Cat: 'Finished Products',
        level2: 'GA',
        level2Cat: 'Finished Products - Beverages',
        level3: 'GA01',
        level3Cat: 'Finished Products - (Fruit) Juice'
      },
      {
        cmg: 'CMG0396',
        desc: 'Finished Products - Whisk(e)y (incl Malts) and Bourbon',
        leader: 'Carlo Garza',
        level1: 'G',
        level1Cat: 'Finished Products',
        level2: 'GA',
        level2Cat: 'Finished Products - Beverages',
        level3: 'GA08',
        level3Cat: 'Finished Products - Spirits'
      },
      {
        cmg: 'CMG0397',
        desc: 'Finished Products - Vodka',
        leader: 'Carlo Garza',
        level1: 'G',
        level1Cat: 'Finished Products',
        level2: 'GA',
        level2Cat: 'Finished Products - Beverages',
        level3: 'GA08',
        level3Cat: 'Finished Products - Spirits'
      },
      {
        cmg: 'CMG0398',
        desc: 'Finished Products - Brandy/Cognac',
        leader: 'Carlo Garza',
        level1: 'G',
        level1Cat: 'Finished Products',
        level2: 'GA',
        level2Cat: 'Finished Products - Beverages',
        level3: 'GA08',
        level3Cat: 'Finished Products - Spirits'
      },
      {
        cmg: 'CMG0399',
        desc: 'Finished Products - Rum',
        leader: 'Carlo Garza',
        level1: 'G',
        level1Cat: 'Finished Products',
        level2: 'GA',
        level2Cat: 'Finished Products - Beverages',
        level3: 'GA08',
        level3Cat: 'Finished Products - Spirits'
      },
      {
        cmg: 'CMG0400',
        desc: 'Finished Products - Gin',
        leader: 'Carlo Garza',
        level1: 'G',
        level1Cat: 'Finished Products',
        level2: 'GA',
        level2Cat: 'Finished Products - Beverages',
        level3: 'GA08',
        level3Cat: 'Finished Products - Spirits'
      },
      {
        cmg: 'CMG0401',
        desc: 'Finished Products - Tequila',
        leader: 'Carlo Garza',
        level1: 'G',
        level1Cat: 'Finished Products',
        level2: 'GA',
        level2Cat: 'Finished Products - Beverages',
        level3: 'GA08',
        level3Cat: 'Finished Products - Spirits'
      },
      {
        cmg: 'CMG0402',
        desc: 'Finished Products - Other Spirits and Liquors',
        leader: 'Carlo Garza',
        level1: 'G',
        level1Cat: 'Finished Products',
        level2: 'GA',
        level2Cat: 'Finished Products - Beverages',
        level3: 'GA08',
        level3Cat: 'Finished Products - Spirits'
      },
      {
        cmg: 'CMG0403',
        desc: 'Finished Products - Pre-Mixed Spirits and RTDs',
        leader: 'Carlo Garza',
        level1: 'G',
        level1Cat: 'Finished Products',
        level2: 'GA',
        level2Cat: 'Finished Products - Beverages',
        level3: 'GA06',
        level3Cat: 'Finished Products - Pre-mixed Spirits'
      },
      {
        cmg: 'CMG0404',
        desc: 'Finished Products - Syrup',
        leader: 'Carlo Garza',
        level1: 'G',
        level1Cat: 'Finished Products',
        level2: 'GA',
        level2Cat: 'Finished Products - Beverages',
        level3: 'GA09',
        level3Cat: 'Finished Products - Syrup'
      },
      {
        cmg: 'CMG0405',
        desc: 'Finished Products - Still Water',
        leader: 'Carlo Garza',
        level1: 'G',
        level1Cat: 'Finished Products',
        level2: 'GA',
        level2Cat: 'Finished Products - Beverages',
        level3: 'GA10',
        level3Cat: 'Finished Products - Water'
      },
      {
        cmg: 'CMG0406',
        desc: 'Finished Products - Sparkling Water',
        leader: 'Carlo Garza',
        level1: 'G',
        level1Cat: 'Finished Products',
        level2: 'GA',
        level2Cat: 'Finished Products - Beverages',
        level3: 'GA10',
        level3Cat: 'Finished Products - Water'
      },
      {
        cmg: 'CMG0407',
        desc: 'Finished Products - Port /Sherry /Vermouth (PSV)',
        leader: 'Carlo Garza',
        level1: 'G',
        level1Cat: 'Finished Products',
        level2: 'GA',
        level2Cat: 'Finished Products - Beverages',
        level3: 'GA05',
        level3Cat: 'Finished Products - Fortified wine'
      },
      {
        cmg: 'CMG0408',
        desc: 'Finished Products - Red Wine',
        leader: 'Carlo Garza',
        level1: 'G',
        level1Cat: 'Finished Products',
        level2: 'GA',
        level2Cat: 'Finished Products - Beverages',
        level3: 'GA11',
        level3Cat: 'Finished Products - Wine'
      },
      {
        cmg: 'CMG0409',
        desc: 'Finished Products - White Wine',
        leader: 'Carlo Garza',
        level1: 'G',
        level1Cat: 'Finished Products',
        level2: 'GA',
        level2Cat: 'Finished Products - Beverages',
        level3: 'GA11',
        level3Cat: 'Finished Products - Wine'
      },
      {
        cmg: 'CMG0410',
        desc: 'Finished Products - Rosé Wine',
        leader: 'Carlo Garza',
        level1: 'G',
        level1Cat: 'Finished Products',
        level2: 'GA',
        level2Cat: 'Finished Products - Beverages',
        level3: 'GA11',
        level3Cat: 'Finished Products - Wine'
      },
      {
        cmg: 'CMG0411',
        desc: 'Finished Products - Sparkling Wine/Champagne',
        leader: 'Carlo Garza',
        level1: 'G',
        level1Cat: 'Finished Products',
        level2: 'GA',
        level2Cat: 'Finished Products - Beverages',
        level3: 'GA11',
        level3Cat: 'Finished Products - Wine'
      },
      {
        cmg: 'CMG0412',
        desc: 'Finished Products - Dairy Drinks',
        leader: 'Carlo Garza',
        level1: 'G',
        level1Cat: 'Finished Products',
        level2: 'GA',
        level2Cat: 'Finished Products - Beverages',
        level3: 'GA04',
        level3Cat: 'Finished Products - Dairy Drinks'
      },
      {
        cmg: 'CMG0413',
        desc: 'Finished Products - Coffee',
        leader: 'Carlo Garza',
        level1: 'G',
        level1Cat: 'Finished Products',
        level2: 'GB',
        level2Cat: 'Finished Products - Food',
        level3: 'GB01',
        level3Cat: 'Finished Products - Coffee & Tea'
      },
      {
        cmg: 'CMG0414',
        desc: 'Finished Products - Tea',
        leader: 'Carlo Garza',
        level1: 'G',
        level1Cat: 'Finished Products',
        level2: 'GB',
        level2Cat: 'Finished Products - Food',
        level3: 'GB01',
        level3Cat: 'Finished Products - Coffee & Tea'
      },
      {
        cmg: 'CMG0415',
        desc: 'Finished Products - Food',
        leader: 'Carlo Garza',
        level1: 'G',
        level1Cat: 'Finished Products',
        level2: 'GB',
        level2Cat: 'Finished Products - Food',
        level3: 'GB02',
        level3Cat: 'Finished Products - Food'
      },
      {
        cmg: 'CMG0416',
        desc: 'Finished Products - Other Non-Food',
        leader: 'Carlo Garza',
        level1: 'G',
        level1Cat: 'Finished Products',
        level2: 'GC',
        level2Cat: 'Finished Products - Non-Food',
        level3: 'GC01',
        level3Cat: 'Finished Products - Other Non-Food'
      },
      {
        cmg: 'CMG0425',
        desc: 'Finished Products - Alcoholic fruit (other than grape) wine',
        leader: 'Carlo Garza',
        level1: 'G',
        level1Cat: 'Finished Products',
        level2: 'GA',
        level2Cat: 'Finished Products - Beverages',
        level3: 'GA11',
        level3Cat: 'Finished Products - Wine'
      },
      {
        cmg: 'CMG0428',
        desc: 'Supply Chain Consultancy',
        leader: 'Carlo Garza',
        level1: 'C',
        level1Cat: 'Business Services',
        level2: 'CC',
        level2Cat: 'Professional Services',
        level3: 'CC02',
        level3Cat: 'Consultancy'
      },
      {
        cmg: 'CMG0459',
        desc: 'Insurance - Pension Schemes',
        leader: 'Carlo Garza',
        level1: 'C',
        level1Cat: 'Business Services',
        level2: 'CC',
        level2Cat: 'Professional Services',
        level3: 'CC03',
        level3Cat: 'Insurance'
      },
      {
        cmg: 'CMG0494',
        desc: 'Finished Products - Cigarrettes & Tabacco',
        leader: 'Carlo Garza',
        level1: 'G',
        level1Cat: 'Finished Products',
        level2: 'GC',
        level2Cat: 'Finished Products - Non-Food',
        level3: 'GC01',
        level3Cat: 'Finished Products - Other Non-Food'
      },
      {
        cmg: 'CMG0498',
        desc: 'Training Materials',
        leader: 'Carlo Garza',
        level1: 'C',
        level1Cat: 'Business Services',
        level2: 'CA',
        level2Cat: 'HR',
        level3: 'CA02',
        level3Cat: 'HR Procurement'
      },
      {
        cmg: 'CMG9903',
        desc: 'CMG BS Not Specified',
        leader: 'Carlo Garza',
        level1: 'C',
        level1Cat: 'Business Services',
        level2: 'CZ',
        level2Cat: 'Business Services Not Specified',
        level3: 'CZ99',
        level3Cat: 'Business Services Not Specified'
      },
      {
        cmg: 'CMG9906',
        desc: 'CMG Finished Products Not Specified',
        leader: 'Carlo Garza',
        level1: 'G',
        level1Cat: 'Finished Products',
        level2: 'GC',
        level2Cat: 'Finished Products - Non-Food',
        level3: 'GC01',
        level3Cat: 'Finished Products - Other Non-Food'
      }
    ]
  }
}